import Alpine from "../alpine.js"
import { client } from "../client.js"

Alpine.data('communityPostCommentForm', (postId) => ({
  postId,
  body: "",
  submit ($event) {
    this.$refs.button.setAttribute("disabled", "")
    client.post(`/posts/${this.postId}/post_comments`, { post_comment: { body: this.body } })
      .then(() => { Turbo.visit(window.location.href) })
      .catch((error) => {
        console.log(error)
        this.$refs.button.removeAttribute("disabled", "")
      })
  }
}))
